// 글로벌 에러 처리를 위한 store
import { create } from 'zustand';

/**
 * 향후 개별 요청을 추적해야할 경우 LoadingData 사용
 * requestId를 붙여야할듯?
 */
interface LoadingData {
  isLoadingFrom: string;
  metadata?: string;
}

/**
 * 여러개의 요청에 의해 isLoading이 true가 되는데
 * 가장 먼저 온 응답에 의해
 * 다른 요청에 대한 응답이 끝나지 않았는데
 * isLoading이 false가 되는 것을 방지하기 위해
 * isLoadingPipe 배열을 사용
 */
interface globalLoadingState {
  isLoading: number;
  addLoading: () => void;
  popLoading: () => void;
}

export const useLoadingStore = create<globalLoadingState>((set) => ({
  isLoading: 0,
  addLoading: () => set((state) => ({ isLoading: state.isLoading + 1 })),
  popLoading: () => set((state) => ({ isLoading: state.isLoading - 1 })),
}));